import { useState } from "react";

import { showToast } from "@/components/ui";
import { cn } from "@/lib/utils";

import { ExpanderSummary } from "./ExpanderSummary";

type Props = { row: Record<string, unknown>; store: string };

export function RawJsonPanel({ row, store }: Props) {
  const [copied, setCopied] = useState(false);
  const json = JSON.stringify(row.marketplaceRawJson ?? {}, null, 2);
  const copy = async () => {
    try {
      await navigator.clipboard.writeText(json);
      setCopied(true);
      window.setTimeout(() => setCopied(false), 1500);
    } catch (error) {
      showToast.error(
        "Copy failed",
        error instanceof Error ? error.message : "Could not copy the JSON.",
      );
    }
  };
  return (
    <details className="group rounded-xl border border-slate-200 bg-white dark:border-slate-800 dark:bg-slate-900">
      <ExpanderSummary className="w-full rounded-xl px-3.5 py-3 text-sm font-semibold text-slate-700 dark:text-slate-200">
        {`Raw JSON from ${store}`}
      </ExpanderSummary>
      <div className="flex items-center justify-between gap-2 px-3.5">
        <span className="text-xs text-slate-500 dark:text-slate-400">
          Exactly what {store} sends for this field.
        </span>
        <button
          type="button"
          onClick={() => void copy()}
          className={cn(
            "shrink-0 rounded-md border border-slate-200 px-2.5 py-1 text-xs font-medium text-slate-700",
            "hover:bg-slate-100 active:scale-[0.97] dark:border-slate-700 dark:text-slate-300 dark:hover:bg-slate-800",
            "focus:outline-none focus-visible:ring-2 focus-visible:ring-indigo-500",
            "motion-safe:transition-transform motion-safe:duration-100",
          )}
        >
          {copied ? "Copied" : "Copy JSON"}
        </button>
      </div>
      <pre className="mx-3.5 mb-3.5 mt-2 max-h-80 overflow-auto rounded-lg border border-slate-200 bg-slate-50 p-3 font-mono text-xs leading-relaxed text-slate-800 dark:border-slate-800 dark:bg-slate-950 dark:text-slate-200">
        <code>{json}</code>
      </pre>
    </details>
  );
}
